// extracted by mini-css-extract-plugin
export default {"recos":"g3-z","productCardOverride":"h3-z","rowHasBadge":"i3-z"};